import React from 'react';
import { RadioGroup } from 'react-form';

import RadioButton from '../../../Form/RadioButton';
import { sportTypeIds } from '../../../../utils/eventConstants';

const EventSport = (props) => {
    const { field, className } = props;
    return (
        <div className={className}>
            <RadioGroup field={field}>
                <div className="row">
                    <div className="col-12">
                        <label>
                            For what sport are you creating this event?
                        </label>
                    </div>
                    <div className="col-12">
                        <RadioButton
                            key={1}
                            label={'Tennis'}
                            value={sportTypeIds.TENNIS}
                            id="tennis"
                        />
                    </div>
                    <div className="col-12">
                        <RadioButton
                            key={2}
                            label={'Pickleball'}
                            value={sportTypeIds.PICKLEBALL}
                            id="pickleball"
                        />
                    </div>
                </div>
            </RadioGroup>
        </div>
    );
};

export default EventSport;
